import React from 'react'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'

import style from './style.styl'

import downCaretSrc from '!svg-inline!images/svg/down-caret.svg'

const Accordion = ({ title, description, children, className, rightContent, open, onToggle, locked }) => (
  <div className={cx(style.Accordion, className, { 'is-open': open, 'is-locked': locked })}>
    <div className="header flex-space-between" onClick={onToggle}>
      <div>
        <h1>{title}</h1>
        <h2>{description}</h2>
      </div>
      { !!rightContent && rightContent }
      { !rightContent && !!onToggle &&
        <IconSVG src={downCaretSrc} className="down-caret-icon" />
      }
    </div>
    {open && <div className="content">{children}</div>}
  </div>
)

export default Accordion



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Accordion/index.js